module.exports = __webpack_public_path__ + "static/media/produce_banner_ja.c76d30b9.png";